const SUPABASE_ACTIVITY_STEPS_EDITOR_URL =
  "https://educationforall.app.n8n.cloud/webhook/Activity%20Steps%20Editor%20-%20SB";
const REACT_CLINICIAN_PORTAL_CALLER = "react-clinician-portal";

function addReactPortalReturnContext(url: URL, returnUrl: string): void {
  const returnDestination = new URL(returnUrl, window.location.origin);
  returnDestination.searchParams.delete("clinicianCode");
  url.searchParams.set("caller", REACT_CLINICIAN_PORTAL_CALLER);
  url.searchParams.set("returnUrl", returnDestination.toString());
}

export function buildHomeworkEditStepsUrl({
  clinicianCode,
  patientId,
  homeworkAssignmentId,
  returnUrl,
}: {
  clinicianCode: string;
  patientId: string;
  homeworkAssignmentId: string;
  returnUrl: string;
}): string {
  const url = new URL(SUPABASE_ACTIVITY_STEPS_EDITOR_URL);
  url.searchParams.set("source", "homework");
  url.searchParams.set("recordId", homeworkAssignmentId);
  url.searchParams.set("homeworkAssignmentId", homeworkAssignmentId);
  url.searchParams.set("db", "supabase");
  url.searchParams.set("clinicianCode", clinicianCode);
  url.searchParams.set("patientId", patientId);
  addReactPortalReturnContext(url, returnUrl);
  return url.toString();
}

export function buildTemplateEditStepsUrl({
  clinicianCode,
  templateId,
  returnUrl,
}: {
  clinicianCode: string;
  templateId: string;
  returnUrl: string;
}): string {
  const url = new URL(SUPABASE_ACTIVITY_STEPS_EDITOR_URL);
  url.searchParams.set("source", "template");
  url.searchParams.set("recordId", templateId);
  url.searchParams.set("db", "supabase");
  url.searchParams.set("clinicianCode", clinicianCode);
  addReactPortalReturnContext(url, returnUrl);
  return url.toString();
}
